import Review1 from "../../../../../public/refer/reviews/review1.png";
import Review2 from "../../../../../public/refer/reviews/review2.png";
import Review3 from "../../../../../public/refer/reviews/review3.png";

export const reviews = [
  {
    src: Review1,
    reviewer: "Shari",
    review:
      "“I love Humming homes! This team has helped me and my husband manage our house projects and get the best vendor for the work. The worst part about house projects is getting vendors to call you back and come for a quote. Humming Homes helps to eliminate that for us and creates an experience as if we have a personal assistant! I highly recommend using Humming Homes!”"
  },
  {
    src: Review2,
    reviewer: "Aubrey",
    review:
      "“Humming Homes has been an absolute god send.  They are responsive, helpful and a pleasure to work with. Knowing that I have them for my home has given me peace of mind. They have long standing connections to vendors and take the time to answer any questions I may have, (and I usually have a lot ;).  They are able to help me make informed decisions on my home projects and I am extremely grateful for the team.”"
  },
  {
    src: Review3,
    reviewer: "John",
    review:
      "“I have been a subscriber for a couple of months.  It's a game changer.  They have professional polite staff and make dealing with all the household maintenance and handyman jobs easy. All the contractors have been great so far. Done well on time with solid work.  Night and day from what we had to deal with in the past.”"
  }
];
